<ngx-monaco-editor
  name="n1qlSelectStatement"
  #n1qlEditor
  [options]="editorOptions"
  [(ngModel)]="tempCategory.chargeDescriptionSelectorN1QL"
  (keyup)="updateTempCategory($event.target.value)"
  (keyup.delete)="updateTempCategory($event.target.value)"
  (keyup.backspace)="updateTempCategory($event.target.value)"
></ngx-monaco-editor>
